var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnfragen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Anfragen"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Anfragen",
    clipPath: "url(#clip-Anfragen)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_187",
    "data-name": "Gruppe 187",
    transform: "translate(7.501 12.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_42",
    "data-name": "Pfad 42",
    d: "M41.192,221H4.524A4.553,4.553,0,0,0,0,225.524v27.144a4.553,4.553,0,0,0,4.524,4.524H41.192a4.553,4.553,0,0,0,4.524-4.524V225.524A4.553,4.553,0,0,0,41.192,221m2.619,31.667a2.642,2.642,0,0,1-2.619,2.619H4.524A2.642,2.642,0,0,1,1.9,252.667V225.524A2.642,2.642,0,0,1,4.524,222.9H41.192a2.642,2.642,0,0,1,2.619,2.619Z",
    transform: "translate(0 -221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_43",
    "data-name": "Pfad 43",
    d: "M37.011,246.139l9.39-9.42a.943.943,0,0,0-1.333-1.333L30.4,250.053,16.019,235.719a.943.943,0,0,0-1.333,1.333l9.334,9.334-9.191,9.191a.921.921,0,0,0,0,1.333.94.94,0,0,0,.667.286,1.05,1.05,0,0,0,.714-.286l9.145-9.189,4.379,4.379a.921.921,0,0,0,1.333,0l4.612-4.626,9.436,9.436a.921.921,0,0,0,1.333,0,.921.921,0,0,0,0-1.333Z",
    transform: "translate(-7.543 -228.385)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnfragen);
export default __webpack_public_path__ + "static/media/Anfragen.74d1e284d7a65819dc87da1ad24419e6.svg";
export { ForwardRef as ReactComponent };